// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-fixed-bottom{position:fixed;bottom:0;right:0}.case-schedule{height:100%;-webkit-transform:translateX(0);transform:translateX(0)}", ""]);
// Exports
module.exports = exports;
